/**
 * AclListCtrl controller
 * Show all Acl
 */
import { ACL_TYPES } from 'app/core/constants'
import { keyValue } from '../../app/helpers/entity'

// controller mixins
AclListCtrl.mixes = [
  'onOffCtrlMixin',
  'networks'
]

/**
 * AclListCtrl controller
 *
 * @class AclListCtrl
 * @memberof mwApp/acls
 * @see mwApp/acl
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/aclList.controller:AclListCtrl
 */
/* @ngInject */
export default function AclListCtrl ($scope, $location, $uibModal, Acl, Network, forNetwork) {
  var vm = this
  if (forNetwork) {
    vm.withNetworkName = forNetwork.name
  }

  vm.isFound = false

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * @description networkId parameter from networks list
   *
   * @type {null|String}
   */
  vm.withNetworkId = $location.$$search.networkId

  /**
   * @description get all networks
   */
  Network.loadAll('?count=true')
    .then(networks => {
      vm.networks = networks
      vm.networksNames = networks.map(keyValue())
    })

  /**
   * Constant with types
   *
   * @type {Object}
   */
  vm.acl_types = ACL_TYPES

  /**
   * Acl list
   *
   * @memberof mwApp/aclList.controller:AclListCtrl
   * @type {models.Acl[]}
   */
  vm.acls = []

  /**
   * Reset acls with network id
   *
   */
  vm.resetWithNetwork = function () {
    vm.withNetworkId = null
    $location.search('networkId', null)
    $scope.$broadcast('refreshTable')
  }

  /**
   * ACLs intersections and permission popup
   *
   * @memberof mwApp/aclList.controller:AclListCtrl
   * @function
   */
  vm.aclsIntersections = function (list) {
    $uibModal.open({
      templateUrl: 'components/acls/views/aclsIntersections.html',
      controller: 'AclsIntersections as vm',
      animation: false,
      size: 'lg',
      resolve: {
        list: function () {
          return list
        }
      }
    })
  }

  /**
   * Get Acl list from backend
   *
   * @memberof mwApp/aclList.controller:AclListCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getAclList = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }
    tableState.search.predicateObject = { ...tableState.search.predicateObject, networkId: vm.withNetworkId }

    Acl.loadSmart(tableState)
      .then(data => {
        vm.acls = []
        data.content.forEach(acl => {
          vm.acls.push(new Acl(acl))
        })
        vm.isFound = !!vm.acls.length
        vm.names = []

        vm.acls.forEach((acl) => {
          vm.names.push(acl.name)
        })
        $scope.loading = false
      })
  }

  /**
   * extends onOff() for intersection error handle
   */
  vm._onOff = function (acl) {
    vm.onOff(acl)
      .catch(error => {
        if (error.newData) {
          vm.aclsIntersections(error.newData)
        }
      })
  }

  vm.delete = function (acl) {
    acl._delete().then(() => {
      $scope.$broadcast('refreshTable')
    })
  }
}
